var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotes(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.177 0a1.765 1.765 0 00-1.765 1.765v5.882a1.765 1.765 0 001.764 1.765h7.06A1.765 1.765 0 0020 7.647V1.765A1.765 1.765 0 0018.235 0h-7.058zm1.176 5.883h4.706a.588.588 0 010 1.176h-4.706a.588.588 0 010-1.176zm-.588-2.942a.588.588 0 01.588-.588h4.706a.588.588 0 110 1.177h-4.706a.588.588 0 01-.588-.589zm-8.706-.588h5.176v5.294a2.941 2.941 0 002.942 2.942h7.058c.202 0 .398-.02.588-.06v2.737c0 1.669-1.369 3.02-3.058 3.02h-5.4l-4.72 3.483A1.189 1.189 0 014 19.535a1.153 1.153 0 01-.234-.694v-2.556h-.706C1.369 16.285 0 14.933 0 13.266V5.372c0-1.667 1.37-3.019 3.059-3.019z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default ForwardRef;